import type { FC, MouseEvent } from 'react';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';
import styles from './Rate.module.scss';
import { THEME_IDS } from '../../../app/themes/types';

type Props = {
  count?: number; // количество звезд
  value?: number | null;
  onChange?: (value: number) => void | null;
  disabled?: boolean;
  testId?: string | null;
  numbered?: boolean;
  themeId?: THEME_IDS;
  isDarkMode?: boolean;
};

const getThemeClassName = (themeId?: THEME_IDS) => {
  switch (themeId) {
    case THEME_IDS.FIRST_THEME:
      return styles['theme_first'];
    case THEME_IDS.PREMIER_THEME:
      return styles['theme_premier'];
    default:
      return styles['theme_default'];
  }
};

export const Rate: FC<Props> = observer(({ count = 5, value, onChange, disabled, testId, numbered, themeId, isDarkMode }) => {
  const handleSelectStar = (e: MouseEvent<HTMLButtonElement>) => {
    if (e.target instanceof HTMLButtonElement && e.target.dataset.starNumber) {
      onChange?.(+e.target.dataset.starNumber);
    }
  };

  return (
    <div
      className={clsx(
        styles.Rate,
        getThemeClassName(themeId),
        isDarkMode && styles.dark_mode,
        value && styles.Rate_selected,
        disabled && styles.Rate_disabled
      )}
      data-testid={testId}
    >
      {Array.from({ length: count }).map((_, i) => {
        const starNumber = i + 1;
        return (
          <button
            key={starNumber}
            className={clsx(
              styles.Star,
              starNumber === value && styles.Star_selected,
              disabled && styles.Star_disabled,
              getThemeClassName(themeId),
              isDarkMode && styles.dark_mode
            )}
            data-star-number={starNumber}
            disabled={disabled}
            onClick={!disabled ? handleSelectStar : undefined}
          >
            {numbered && <span className={styles.StarNumber}>{starNumber}</span>}
          </button>
        );
      })}
    </div>
  );
});
